<template>
    <div class="mineView">
        <div class="mineContent">
            <div class="header">
                <div class="userView">
                    <img class="userImg" :src="userInfo.avatar
                        ? userInfo.avatar
                        : require('../../assets/images/logo.png')
                        " alt="" />
                    <div class="userInfo">
                        <p class="userName">{{ userInfo.name }}</p>
                        <div class="region" v-if="!isStore && planList.length > 0">
                            <p @click="toPage('/plan')">区域代理</p>
                            <img src="../../assets/images/ic_mine_privilege.png" alt="" />
                        </div>
                        <div class="mobile" @click="toPage('/updateMobile')">
                            <p class="userMobile">手机号：{{ userInfo.mobile }}</p>
                            <img src="../../assets/images/ic_update.png" alt="" />
                        </div>
                    </div>
                    <div class="setView">
                        <img class="settingIcon" @click="toPage('/setting')"
                            src="../../assets/images/ic_mine_setting.png" alt="" />
                    </div>

                </div>

            </div>
            <div class="userAccount">
                <div class="accountInfo">
                    <div class="accountLeft">
                        <p class="withdrawAccountTitle">可提现收益</p>

                        <div class="refreshView">
                            <p class="withdrawAccount">¥{{ userInfo.cashAmount }}</p>
                            <img class="settingIcon" @click="refreshAccount"
                                src="../../assets/images/ic_mine_refresh.png" alt="" />
                        </div>
                    </div>
                    <div class="accountBtn">
                        <Button class="withdrawBtn" @click="withdraw">
                            <div class="withdrawBtn">
                                <span>提现</span>
                            </div>
                        </Button>
                    </div>
                </div>
                <div class="accountInfo">
                    <div class="accountLeft">
                        <p class="withdrawAccountTitle">累计收益</p>
                        <p class="totalAccount">¥{{ userInfo.totalAmount }}</p>

                    </div>
                    <div class="recordBtn" @click="toPage('/bill')"> 账单明细
                        <icon name="arrow" />
                    </div>
                </div>
            </div>

            <div class="menuView">
                <CellGroup>
                    <Cell title="订单明细" is-link size="large" to="/order" title-class="toolTitle" v-if="showOrderList">
                        <img src="../../assets/images/ic_order.png" class="icon" slot="icon" alt="" />
                    </Cell>
                    <template v-if="!isStore">
                        <Cell title="推广文案" is-link size="large" to="/share" title-class="toolTitle">
                            <img src="../../assets/images/ic_share.png" class="icon" slot="icon" alt="" />
                        </Cell>
                    </template>
                    <Cell title="帮助中心" is-link size="large" to="/help" title-class="toolTitle">
                        <img src="../../assets/images/ic_help.png" class="icon" slot="icon" alt="" />
                    </Cell>
                    <Cell title="我的消息" is-link size="large" to="/message" title-class="toolTitle">
                        <img src="../../assets/images/ic_mine_message.png" class="icon" slot="icon" alt="" />
                    </Cell>
                    <Cell title="关于我们" is-link size="large" to="/aboutUs" title-class="toolTitle">
                        <img src="../../assets/images/ic_about.png" class="icon" slot="icon" alt="" />
                    </Cell>
                    <Cell title="版权声明" is-link size="large" :url="config.HOST" title-class="toolTitle">
                        <img src="../../assets/images/ic_copyright.png" class="icon" slot="icon" alt="" />
                    </Cell>
                    <Cell title="退出登录" is-link size="large" @click="loginOut" title-class="toolTitle">
                        <img src="../../assets/images/ic_sign_out.png" class="icon" slot="icon" alt="" />
                    </Cell>
                </CellGroup>

            </div>
        </div>
        <div class="headerBg"></div>

        <TabBar :activeIndex="2" />
    </div>
</template>

<script>
/*
 * 个人中心（我的）
 * */
import { Icon, Cell, CellGroup, Button } from "vant";
import { getPlanList, getUpgradeInfo } from "../../api/mine";
import { getTransferAccount } from "../../api/withdraw";
import TabBar from "../../components/TabBar";
import config from "../../Config";
import { mapState } from "vuex";
export default {
    name: "Mine",
    components: {
        Icon,
        Cell,
        CellGroup,
        Button,
        TabBar
    },
    data() {
        return {
            showOrderList: false,
            config,
            planList: []
        };
    },
    computed: {
        ...mapState(["userInfo", "isStore"])
    },
    methods: {
        // 提现
        withdraw() {
            getTransferAccount().then(res => {
                const tempAccountList = res.find(item => item.type === 'WX');
                if (tempAccountList) {
                    this.toPage("/withdraw");
                } else {
                    this.toPage("/drawMode");
                }
            });
        },
        // 退出登录
        loginOut() {
            this.$store.commit("SET_TOKEN", null);
            this.toPage("/login", true);
        },
        // 刷新账号
        refreshAccount() {
            this.$store.dispatch('getUserInfo');
        }
    },
    mounted() {
        // 判断是否显示订单明细
        if (this.isStore) {
            this.showOrderList = this.userInfo.orderDetail !== "CLOSE";
        }
    },
    created() {
        getPlanList().then(res => {
            this.planList = res;
        });
        // 获取升级信息
        getUpgradeInfo().then(res => {
            res &&
                this.alert({
                    text: res
                });
        });
    }
};
</script>

<style lang="less" scoped>
.mineView {
    position: relative;
    min-height: 100vh;
    padding-bottom: 50px;
    background-color: #f7f7f7;
    box-sizing: border-box;

    .mineContent {
        position: relative;
        padding: 0 5.1vw 3.6vw 5.6vw;
        box-sizing: border-box;
        z-index: 1;

        .header {
            padding: 5vw 0 3.6vw 0;
            box-sizing: border-box;

            .userView {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 16.3vw;
                padding: 1.5vw 0 2.4vw;
                color: #fff;

                .userImg {
                    width: 16.3vw;
                    height: 16.3vw;
                    margin-right: 3.2vw;
                    border-radius: 50%;
                    background-color: white;
                }

                .userInfo {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    height: 100%;
                    flex: 1;

                    .userName {
                        margin-bottom: 0.7vw;
                        font-size: 4.5vw;
                        color: #ffffff;
                        line-height: 6.4vw;
                    }

                    .region {
                        display: flex;
                        align-items: center;
                        margin: 0.5vw 0;
                        font-size: 3vw;
                        color: #ffffff;

                        img {
                            width: 2.5vw;
                            height: 3vw;
                            margin-left: 1vw;
                        }
                    }

                    .mobile {
                        display: flex;
                        align-items: center;

                        .userMobile {
                            font-size: 3.2vw;
                            color: #ffffff;
                            line-height: 4.4vw;
                        }

                        img {
                            width: 3.2vw;
                            height: 3.8vw;
                            margin-left: 2vw;
                        }
                    }
                }

                .setView {
                    display: flex;
                    align-items: center;
                    padding: 2vw;
                    background-color: rgba(255, 255, 255, 0.15);
                    border-radius: 50%;

                    .settingIcon {
                        width: 5vw;
                        height: 4.5vw;
                    }
                }
            }
        }

        .userAccount {
            background-color: #FFF;
            box-shadow: 0 0.53vw 1.33vw -0.53vw rgba(0, 0, 0, 0.08);
            border-radius: 2vw;
            padding: 5vw 3vw;
            box-sizing: border-box;

            .accountInfo {
                display: flex;
                align-items: center;
                justify-content: space-between;

                &:nth-child(1) {
                    padding-bottom: 3.5vw;
                    border-bottom: 1px solid rgba(223, 223, 223, 1);
                }

                &:nth-child(2) {
                    padding-top: 3.5vw;

                }

                .accountLeft {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: start;

                    .withdrawAccountTitle {
                        font-size: 3.2vw;
                        color: rgba(156, 163, 175, 1);
                        margin-bottom: 1.5vw;
                    }

                    .withdrawAccount {
                        font-size: 6.4vw;
                        color: rgba(31, 41, 55, 1);
                        font-weight: bold;
                        margin-right: 2vw;
                    }

                    .totalAccount {
                        font-size: 4.4vw;
                        color: rgba(31, 41, 55, 1);
                        font-weight: bold;
                    }

                    .refreshView {
                        display: flex;
                        align-items: center;
                        padding: 2vw;
                        background-color: rgba(255, 255, 255, 0.15);
                        border-radius: 50%;

                        .settingIcon {
                            width: 5vw;
                            height: 5vw;
                        }
                    }
                }

                .accountBtn {
                    display: flex;
                    align-items: center;

                    .withdrawBtn {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 20.7vw;
                        height: 8.7vw;
                        background-color: #2895ff;
                        border-radius: 1.3vw;
                        font-size: 3.2vw;
                        color: #ffffff;
                    }
                }

                .recordBtn {
                    display: flex;
                    align-items: center;
                    color: #2895ff;
                    font-size: 3.2vw;
                }
            }
        }

        .menuView {
            background-color: #FFF;
            box-shadow: 0 0.53vw 1.33vw -0.53vw rgba(0, 0, 0, 0.08);
            border-radius: 2vw;
            padding: 5vw 2vw;
            box-sizing: border-box;
            margin-top: 4vw;

            .icon {
                width: 5.9vw;
                height: 5.9vw;
                margin-right: 5.7vw;
            }

            .toolTitle {
                font-size: 4.5vw;
                color: #333333;
            }
        }
    }




}

.headerBg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 35vw;
    border-bottom-right-radius: 4vw;
    border-bottom-left-radius: 4vw;
    background-color: #2895ff;
}
</style>



// WEBPACK FOOTER //
// src/page/mine/Index.vue